import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import SmartDeadlinePopover from
  '../../../../containers/smart-deadline-popover.container.js';

import {
  TIME_FORMAT_RELATIVE as format,
  TIME_FORMAT_HOUR,
  Time,
} from '../../../../components/Time';
import Purchase from '../../../lib/purchase';

const CommitDeadline = ({ deadline, isCompleted, lastPaymentSubmittedAt, isActive }) => {
  const expired = Purchase.isDateExpired(deadline);

  let errorClass = '';

  if (isActive && expired && !isCompleted) {
    errorClass = 'coral-error';
  }

  let timeToShow = deadline;
  let displayText = <Time format={format} time={timeToShow} />;

  if (expired) {
    displayText = (
      <FormattedMessage
        id="commitDeadline.offerExpired"
        defaultMessage="Offer expired"
      />
    );
  }

  if (isCompleted) {
    displayText = (
      <FormattedMessage
        id="commitDeadline.groupEnded"
        defaultMessage="Group ended"
      />
    );
    timeToShow = lastPaymentSubmittedAt;
  }

  return (
    <div className="row align-items-center mb-4">
      {renderCalendar(errorClass)}
      <div className="col-9">
        <h4 className={`mb-0 ${errorClass}`}>{displayText}</h4>
        <span className="contribution-muted-text">
          <Time time={timeToShow} />
          {' '}
          <Time time={timeToShow} format={TIME_FORMAT_HOUR} timezone={moment.tz.guess()} />
          {' '}
        </span>
        <SmartDeadlinePopover />
      </div>
    </div>
  );
};

const renderCalendar = (errorClass) => {
  const className = 'fa fa-calendar round-border medium ' +
    `with-background clear-blue mb-0 ${errorClass}`;
  return (
    <div className="col-3 text-center">
      <i className={className} />
    </div>
  );
};



export default CommitDeadline;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/commit-deadline.js